import amazonBalance from './amazonBalance';
import bestBuy from './bestBuy';
import target from './target';
import mastercard from "./mastercard";
import paypalAdaptive from "./paypalAdaptive";
import paypalPayouts from "./paypalPayouts";
import finix from './finix';
import starbucks from './starbucks';
import travelBank from './travelBank';
import bassProShops from './bassProShops';
import officeDepot from './officeDepot';
import blackhawkAmazon from './blackhawkAmazon';

import { PAYMENT_NETWORKS } from "../../../../utils/enums";

/* eslint no-template-curly-in-string: "off" */
const paymentNetworks = {
  [PAYMENT_NETWORKS.AMAZON_BALANCE]: amazonBalance,
  [PAYMENT_NETWORKS.BEST_BUY]: bestBuy,
  [PAYMENT_NETWORKS.TARGET]: target,
  [PAYMENT_NETWORKS.MASTERCARD]: mastercard,
  [PAYMENT_NETWORKS.PAYPAL_ADAPTIVE_PAYMENTS]: paypalAdaptive,
  [PAYMENT_NETWORKS.PAYPAL_PAYOUTS]: paypalPayouts,
  [PAYMENT_NETWORKS.OCT_FINIX]: finix,
  [PAYMENT_NETWORKS.STARBUCKS]: starbucks,
  [PAYMENT_NETWORKS.JETBLUE_TRAVEL_BANK]: travelBank,
  [PAYMENT_NETWORKS.BASS_PRO_SHOPS]: bassProShops,
  [PAYMENT_NETWORKS.OFFICE_DEPOT]: officeDepot,
  [PAYMENT_NETWORKS.EGIFT_BLACKHAWK_AMAZON]: blackhawkAmazon,
};

export default paymentNetworks;
